
/**
 * Footer component
 */
export default {};
